module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_7042.e3dfb1c5.png";